import { useLocalSearchParams } from 'expo-router';
import { ConfirmReset } from './containers/ConfirmReset/ConfirmReset';
import { RequestReset } from './containers/RequestReset/RequestReset';

export const ResetPassword = () => {
  const { token } = useLocalSearchParams();
  return (
    <>{!token ? <RequestReset /> : <ConfirmReset token={token as string} />}</>
  );
};
